import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SoffApiResponseDto, SoffApiService } from '@soff/shared-ui';
import { SoffQueryDto } from 'src/app/shared/models/query.model.dto';
import { environment } from 'src/environments/environment';
import { ChangeStatusRequestDto, IncomingTopicTypeDto } from '../models/incoming-topic.model';

@Injectable({
  providedIn: 'root',
})
export class IncomingTopicsV2Service {
  private soffApiService = inject(SoffApiService);

  private readonly baseUrl = environment.apiBaseUrl + '/fieldservice/incoming-topics/v2';

  getIncomingTopics(query?: SoffQueryDto): Observable<SoffApiResponseDto> {
    const params: string[] = [];
    if (typeof query?.limit === 'number') {
      params.push(`limit=${query.limit}`);
    }
    if (query?.offset) {
      params.push(`offset=${query.offset}`);
    }
    if (query?.order) {
      params.push(`orderBy=${query.order}`);
    }
    if (query?.filter) {
      params.push(`filter=${encodeURIComponent(query.filter)}`);
    }
    if (query?.query) {
      params.push(query.query);
    }

    params.push('relatedAggregateTypes=Machine,Workshop,Customer,IncomingTopicType');

    return this.soffApiService.get(`${this.baseUrl}/${params.length ? `?${params.join('&')}` : ''}`).pipe(map(resp => resp.body));
  }

  loadTiles(): Observable<SoffApiResponseDto> {
    const url = environment.apiBaseUrl + '/fieldservice/incoming-topics/v2/tiles?relatedAggregateTypes=IncomingTopicType';
    return this.soffApiService.get(url).pipe(map(resp => resp.body));
  }

  changeIncomingTopicStatus(aggregateId: string, requestBody: ChangeStatusRequestDto): Observable<SoffApiResponseDto> {
    const url = environment.apiBaseUrl + '/fieldservice/incoming-topics/v2/' + aggregateId + '/status';
    return this.soffApiService.patch(url, requestBody).pipe(map(resp => resp.body));
  }

  getIncomingTopicById(aggregateId: string): Observable<SoffApiResponseDto> {
    const url = `${this.baseUrl}/${aggregateId}?relatedAggregateTypes=Machine,Workshop,Customer,IncomingTopicType`;
    return this.soffApiService.get(url).pipe(map(resp => resp.body));
  }

  patchIncomingTopic(aggregateId: string, body: { assignedResourceId?: string | null; dueAt?: string | null }): Observable<SoffApiResponseDto> {
    const url = environment.apiBaseUrl + '/fieldservice/incoming-topics/v2/' + aggregateId;
    return this.soffApiService.patch(url, body).pipe(map(resp => resp.body));
  }

  getIncomingTopicTypes(): Observable<IncomingTopicTypeDto[]> {
    return this.soffApiService.get(`${this.baseUrl}/types`).pipe(map(resp => resp.body?.data ?? []));
  }
}
